import enMessages from '../locales/en.json'
import deMessages from '../locales/de.json'
import esMessages from '../locales/es.json'
import frMessages from '../locales/fr.json'
import jaMessages from '../locales/ja.json'
import ptMessages from '../locales/pt.json'
import ruMessages from '../locales/ru.json'
import zhCnMessages from '../locales/zh-cn.json'
import zhTwMessages from '../locales/zh-tw.json'
import koMessages from '../locales/ko.json'
import viMessages from '../locales/vi.json'
import arMessages from '../locales/ar.json'
import csMessages from '../locales/cs.json'
import daMessages from '../locales/da.json'
import elMessages from '../locales/el.json'
import fiMessages from '../locales/fi.json'
import filMessages from '../locales/fil.json'
import huMessages from '../locales/hu.json'
import idMessages from '../locales/id.json'
import itMessages from '../locales/it.json'
import ltMessages from '../locales/lt.json'
import msMessages from '../locales/ms.json'
import nlMessages from '../locales/nl.json'
import plMessages from '../locales/pl.json'
import roMessages from '../locales/ro.json'
import svMessages from '../locales/sv.json'
import thMessages from '../locales/th.json'
import trMessages from '../locales/tr.json'

// 扁平化嵌套对象的函数
const flattenMessages = (nestedMessages: any, prefix = ''): Record<string, any> => {
  return Object.keys(nestedMessages).reduce((messages: Record<string, any>, key) => {
    const value = nestedMessages[key]
    const prefixedKey = prefix ? `${prefix}.${key}` : key

    if (typeof value === 'string') {
      messages[prefixedKey] = value
    } else if (Array.isArray(value)) {
      // 保留数组类型的值
      messages[prefixedKey] = value
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey))
    }

    return messages
  }, {})
}

export const messages = {
  en: flattenMessages(enMessages),
  de: flattenMessages(deMessages),
  es: flattenMessages(esMessages),
  fr: flattenMessages(frMessages),
  ja: flattenMessages(jaMessages),
  pt: flattenMessages(ptMessages),
  ru: flattenMessages(ruMessages),
  'zh-cn': flattenMessages(zhCnMessages),
  'zh-tw': flattenMessages(zhTwMessages),
  ko: flattenMessages(koMessages),
  vi: flattenMessages(viMessages),
  ar: flattenMessages(arMessages),
  cs: flattenMessages(csMessages),
  da: flattenMessages(daMessages),
  el: flattenMessages(elMessages),
  fi: flattenMessages(fiMessages),
  fil: flattenMessages(filMessages),
  hu: flattenMessages(huMessages),
  id: flattenMessages(idMessages),
  it: flattenMessages(itMessages),
  lt: flattenMessages(ltMessages),
  ms: flattenMessages(msMessages),
  nl: flattenMessages(nlMessages),
  pl: flattenMessages(plMessages),
  ro: flattenMessages(roMessages),
  sv: flattenMessages(svMessages),
  th: flattenMessages(thMessages),
  tr: flattenMessages(trMessages),
}

export const supportedLocales = ['en', 'de', 'es', 'fr', 'ja', 'pt', 'ru', 'zh-cn', 'zh-tw', 'ko', 'vi', 'ar', 'cs', 'da', 'el', 'fi', 'fil', 'hu', 'id', 'it', 'lt', 'ms', 'nl', 'pl', 'ro', 'sv', 'th', 'tr'] as const
export type SupportedLocale = typeof supportedLocales[number]

export const defaultLocale: SupportedLocale = 'en'

// 从URL路径中提取语言
export const getLocaleFromPath = (pathname: string): SupportedLocale => {
  const segments = pathname.split('/').filter(Boolean)
  const firstSegment = segments[0]
  
  if (supportedLocales.includes(firstSegment as SupportedLocale)) {
    return firstSegment as SupportedLocale
  }
  
  return defaultLocale
}

// 获取不带语言前缀的路径
export const getPathWithoutLocale = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean)
  const firstSegment = segments[0]
  
  if (supportedLocales.includes(firstSegment as SupportedLocale)) {
    return '/' + segments.slice(1).join('/')
  }
  
  return pathname
}

// 为路径添加语言前缀
export const getLocalizedPath = (path: string, locale: SupportedLocale): string => {
  if (locale === defaultLocale) {
    return path
  }
  
  const cleanPath = path.startsWith('/') ? path : `/${path}`
  return `/${locale}${cleanPath}`
}

// 检测浏览器语言
// export const detectBrowserLanguage = (): SupportedLocale => {
//   if (typeof window === 'undefined') return defaultLocale
  
//   const browserLang = navigator.language.split('-')[0]
//   return supportedLocales.includes(browserLang as SupportedLocale) 
//     ? browserLang as SupportedLocale 
//     : defaultLocale
// }
